import { Search as SearchIcon } from '@mui/icons-material';
import { Avatar, CardHeader, CardHeaderProps, Divider } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';
import * as i18next from 'i18next';
import { FunctionComponent } from 'react';
import { makeStyles } from 'tss-react/mui';

import AutosuggestChipInput from '@/components/chip-filter/autosuggest-chip-input';
import * as Types from '@/types';

const useStyles = makeStyles()((theme: Theme) => ({
  action: {
    marginTop: 0,
    alignSelf: 'normal',
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(),
  },
}));

interface Chip {
  key: string;
  value: string;
}

interface Props {
  suggestions: Types.Suggestion[];
  applyFilter: (chips: Chip[]) => void;
  placeholderText: string;
  t: i18next.TFunction;
  filters?: Chip[];
  action?: CardHeaderProps['action'];
}

const AutosuggestCardHeader: FunctionComponent<Props> = ({
  suggestions,
  applyFilter,
  filters,
  t,
  placeholderText,
  action,
}) => {
  const theme = useTheme();
  const { classes } = useStyles();

  return (
    <>
      <CardHeader
        classes={{
          action: classes.action,
        }}
        action={<div>{action}</div>}
        avatar={
          <Avatar style={{ backgroundColor: theme.palette.primary.main }}>
            <SearchIcon />
          </Avatar>
        }
        title={
          <AutosuggestChipInput
            suggestions={suggestions}
            applyFilter={applyFilter}
            filters={filters}
            t={t}
            placeholderText={placeholderText}
          />
        }
      />
      <Divider />
    </>
  );
};

export default AutosuggestCardHeader;
